"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const ExpandedCta = _ref => {
  let {
    title,
    primaryBtnHref,
    primaryBtnText,
    secondaryBtnHref,
    secondaryBtnText
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "grid lg:grid-cols-2 gap-2 expandedCta sm:w-[1144px] sm:h-[140x]",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
        className: "text-primaryLight text-[30px] leading-9 text-center",
        children: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "sm:flex justify-center gap-5",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          href: primaryBtnHref,
          className: "primary-btn items-center mt-4 sm:mt-0",
          children: primaryBtnText
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          href: secondaryBtnHref,
          className: "secondary-btn items-center mt-4 sm:mt-0",
          children: secondaryBtnText
        })]
      })
    })]
  });
};
var _default = ExpandedCta;
exports.default = _default;